import { render, staticRenderFns } from "./SummaryTab.vue?vue&type=template&id=7c3d56d6&scoped=true"
import script from "./SummaryTab.vue?vue&type=script&lang=js"
export * from "./SummaryTab.vue?vue&type=script&lang=js"
import style0 from "./SummaryTab.vue?vue&type=style&index=0&id=7c3d56d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3d56d6",
  null
  
)

export default component.exports